<template>
  <div class="tbp">
    <notice v-if="$store.getters.checkNotice"/>
    <paymentStatus :orderDetails="orderDetails"/>
    <refund
      refundTicket="guiderefunddetails"
      tickettype="guideorderdetails"
      v-if="orderDetails.itemList && orderDetails.itemList.some(item => item.ticketStatus == '5') && orderDetails.totalPrice != '0'"
      :itemList="orderDetails.itemList">
    </refund>
    <main>
      <idType v-if="Object.keys(orderDetails).length" :orderDetails="orderDetails"/>
      <ticketState :itemList="orderDetails.itemList" v-if="!(orderDetails.status === '3') && !(orderDetails.status === '0')"/>
      <oddt :orderDetails="orderDetails"/>
      <atourist v-if="orderDetails.status === '0'" :itemList="orderDetails.itemList"/>
    </main>
    <explain/>
    <paytabber :ticketlist="ticketlist" tickettype="guideorderdetails" :payCloseTime="orderDetails.payCloseTime" v-if="orderDetails.status == '0'"/>
    <again refundTicketPath="guiderefundlist" :ticketlist="ticketlist" tickettype="guideorderdetails" @clickAgain="getdata" v-else-if="orderDetails.status == '1'" :orderDetails="orderDetails"/>
    <complete :orderDetails="orderDetails" :ticketlist="ticketlist" :base="orderDetails.itemList" :orderId="orderId" v-else-if="orderDetails.status == '2' || orderDetails.status == '3'"/>
    <againTicketPurchase :ticketlist="ticketlist" :type="'guide'" v-else-if="orderDetails.status == '4'"/>
  </div>
</template>

<script>
import idType from "@/components/order/orderdetails/idType";
import ticketState from "@/components/order/orderdetails/ticketState";
import paymentStatus from "@/components/order/orderdetails/paymentStatus";
import explain from "@/components/order/orderdetails/explain";
import oddt from "@/components/order/orderdetails/oddt";
import atourist from "@/components/order/orderdetails/atourist";
import paytabber from "@/components/order/orderdetails/payTabber";
import again from "@/components/order/orderdetails/again";
import complete from "@/components/order/orderdetails/complete";
import againTicketPurchase from "@/components/order/orderdetails/againTicketPurchase";
import refund from "@/components/order/orderdetails/refund";
import { getGroupOrderSingle } from "@/service/order/guideOrderDetails.js";

export default {
  name: "guideOrderDetails",
  data(){
    return {
      orderDetails: {},
      websorket: null,
      ticketlist: '',
      onceTime: null,
      ticketlist: '',
    }
  },
  created(){
    this.getdata();
  },
  methods: {
    async getdata(){
      const { orderId } = this.$route.query;
      const obj = {
        id: orderId
      };
      const data = await getGroupOrderSingle.call(this, obj);
      if(data.data.status === "0" || data.data.status === "1")this.controlSorket();
      if(!data.data.itemList){
        data.data.itemList = data.data.groupOrderInfoItems;
        if(data.data.itemList[0].itemAttrs){
          data.data.itemList.forEach(item => item.attrList = item.itemAttrs);
        }
      };
      // 额外增加日期判断业务，随时可删
      data.data.itemList.forEach(item => {
        item.attrList.forEach((v => v.cerNo = this.$hiddenCardId(v.cerNo, 4, 4)))
        if(item.ticketStatus == '2' && item.ticketStatusName === "未使用" && item.canRefund == '0'){
          const starttime = new Date(item.refundCloseTime.replace(/-/g, '/'));
          const curtime = new Date();
          if(starttime < curtime){
            item.ticketStatus = '4';
            item.ticketStatusName = '已逾期';
          }
        }
      });
      this.orderDetails = data.data;
      this.initializationTicketlist(this.orderDetails.itemList[0].ticketSn);
      this.mergeOliver();
    },
    initializationTicketlist(ticketSn){
      let touristtype = null;
      let ticketpurchase = null;
      const rootTouristtype = Object.values(this.$store.state.ticketWindow).find((item) => item.some(({ totalOffPeakSeasonProductSns }) => totalOffPeakSeasonProductSns.some(v1 => v1 == ticketSn)))[0].rootTouristtype;
      const _ticketWindow = Object.values(this.$store.state.ticketWindow).filter((item) => item.some(v => v.rootTouristtype === rootTouristtype));
      _ticketWindow.some((item, index) => {
        const findStatus = item.some((v, i) => {
          const _findStatus = v.totalOffPeakSeasonProductSns.some((v1) => v1 === ticketSn);
          if(_findStatus){
            ticketpurchase = i;
            return true;
          };
        });
        if(findStatus){
          touristtype = index;
          return true;
        };
      });
      this.ticketlist = `/${rootTouristtype}/${touristtype}/${ticketpurchase}`;
    },
    controlSorket(){
      const { orderId } = this.$route.query;
      this.websorket = new WebSocket(process.env.VUE_APP_WEBSORKET_BASE_URL + orderId);
      const hearCheck = {
        timeout: 10000,
        timeoutObj: {},
        reset:() => {
          clearInterval(this.timeoutObj);
        },
        start:() =>{
          this.timeoutObj = setInterval(() => {
            this.websorket.send('nowDate' + Date());
          }, hearCheck.timeout)
        },
      };
      const createLink = () => {
        hearCheck.reset();
        hearCheck.start();
      };
      this.websorket.onopen = createLink;
      this.websorket.onmessage = event => {
        const data = event.data && JSON.parse(event.data);
        if(data){
          this.getdata();
          if(data.statusName == "5"){
            this.$toast('退票申请成功');
          };
          this.$loading.loadingStata = false;
        };
      };
      this.websorket.onerror = createLink;
    },
    mergeOliver(){
      if(Object.keys(this.orderDetails).length && this.$store.state.oliver.length){
        const orderDetails = this.orderDetails;
        const mediumList = this.$store.state.oliver;
        orderDetails.itemList.forEach((ticket) => {
          mediumList.some((medium) => {
            if(ticket.ticketSn === medium.ticketSn && ticket.attrList.length === 1){
              ticket.mediaType = 'qr_code';
              ticket.openType = medium.openType;
              return true;
            };
          });
        });
      }
    },
  },
  components: {
    paymentStatus,
    idType,
    ticketState,
    explain,
    oddt,
    atourist,
    paytabber,
    again,
    complete,
    againTicketPurchase,
    refund,
  },
   beforeRouteLeave (to, from, next) {
      clearInterval(this.timeoutObj);
      // console.log(this.websorket)
      if(this.websorket)this.websorket.close();
      // console.log('websocket销毁')
      next();
    }
};
</script>

<style scoped lang='less'>
.tbp {
  padding-bottom: 1.6rem + .346667rem;
  min-height: 100vh;
}
main {
  margin: 0 0.346667rem;
  background: #ffffff;
  box-shadow: 0 0.133333rem 0.08rem rgba(0, 0, 0, 0.01);
  border-radius: 0.08rem;
  overflow: hidden;
}
</style>
